import { Injectable, inject } from '@angular/core';
import { HomeCrmService } from '@app/modules/home/home-crm.service';
import { environment } from '@env/environment';
import { WarehouseService } from '@app/modules/external/warehouse/warehouse.service';
import { FmsService } from '@app/modules/external/fms/fms.service';
import { LoggerSystemService } from '@app/modules/external/logger-system/logger-system.service';
import { LearningSystemService } from '@app/modules/external/learning-system/learning-system.service';
import { AtcSystemService } from '@app/modules/external/atc-system/atc-system.service';

@Injectable({
    providedIn: 'root'
})
export class NavigationService {
    private _homeCrmService = inject(HomeCrmService);
    private _warehouseService = inject(WarehouseService);
    private _fmsService = inject(FmsService);
    private _loggerSystemService = inject(LoggerSystemService);
    private _learningSystemService = inject(LearningSystemService);
    private _atcSystemService = inject(AtcSystemService);

    /**
     * Set CRM URL for home navigation
     */
    setCrmUrl(): void {
        console.log('setCrmUrl');
        this._homeCrmService.crmUrl$ = environment.crmUrl;
    }

    setWarehouseUrl(route?: string): void {
        this._warehouseService.setWarehouseUrl(environment.warehouseUrl, route);
    }

    setFmsUrl(route?: string): void {
        this._fmsService.setFmsUrl(environment.fmsUrl, route);
    }

    setLoggerSystemUrl(route?: string): void {
        this._loggerSystemService.setLoggerSystemUrl(
            environment.loggerSystemUrl,
            route
        );
    }

    setLearningSystemUrl(): void {
        this._learningSystemService.learningSystemUrl$ =
            environment.learningSystemUrl;
    }

    setAtcSystemUrl(): void {
        this._atcSystemService.atcSystemUrl$ = environment.atcSystemUrl;
    }
}

// Global instance that can be accessed from navigation functions
let globalNavigationService: NavigationService | null = null;

/**
 * Initialize the global navigation service
 * This should be called from a component or service that has access to dependency injection
 */
export function initializeNavigationService(service: NavigationService): void {
    globalNavigationService = service;
}

/**
 * Get the global navigation service
 */
export function getGlobalNavigationService(): NavigationService | null {
    return globalNavigationService;
}
